import { useQueryClient } from "@tanstack/react-query";
import {
  PatientIntakeForm,
  PatientIntakeFormControllerApi,
} from "../../../services";
import {
  getConfigObject,
  useMutationWithLoading,
} from "./../../../utils/utils";

type Params = {
  patientIntakeForm: PatientIntakeForm;
  xTENANTID?: string;
  formEntries?: string;
};

/**
 *
 * @author Rajkumar Rathod
 */
export const usePatientIntakeFormCreate = (isPublic?: boolean) => {
  const queryClient = useQueryClient();
  return useMutationWithLoading(
    async (params: Params) =>
      new PatientIntakeFormControllerApi(
        isPublic ? undefined : getConfigObject()
      ).createIntakeForm(
        params.formEntries || "",
        params.patientIntakeForm,
        params.xTENANTID
      ),
    {
      // Submitting an intake form creates a new entry in the chart
      // timeline + may flip a requiring action — invalidate both. No-op
      // when the timeline isn't mounted (e.g. on the patient portal).
      onSuccess: () => {
        queryClient.invalidateQueries({ queryKey: ["chronological-record"] });
        queryClient.invalidateQueries({ queryKey: ["requiring-action"] });
      },
    }
  );
};
